import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function MS_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <MS_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <MS_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function MS_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>How does React work?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          React creates a digital DOM. When nation changes in a element it firstly runs a “diffing” set of rules, which identifies what has changed inside the virtual DOM. The second one step is reconciliation, wherein it updates the DOM with the consequences of diff.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What Is Replication In MongoDB?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Replication is the procedure of synchronizing records across more than one server. Replication gives redundancy and will increase data availability. With a couple of copies of records on specific database servers, replication protects a database from the lack of a single server. Replication additionally lets in you to recover from hardware failure and carrier interruptions.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What are Higher-Order components?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A higher-order element (HOC) is a function that takes a aspect and returns a brand new factor. Basically, it’s a sample this is derived from React’s compositional nature We name them as “natural’ components” because they could be given any dynamically provided child issue but they gained’t alter or reproduction any behavior from their input additives.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default MS_FAQ_page
